module.exports = __webpack_public_path__ + "static/media/arrow.d7b0c05d.svg";